import React from 'react';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import PropTypes from 'prop-types';
import { SketchPicker } from 'react-color';
// Core components
import Avatar from 'components/core/Avatar';
import Popover from 'components/core/Popover';
import TextField from 'components/core/TextField';

const ColorPicker = ({ value, errorText, onChange }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (e) => {
    setAnchorEl(e.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = !!anchorEl;

  return (
    <React.Fragment>
      <div role="button" tabIndex={0} onClick={handleClick}>
        <TextField
          readonly
          label={<LocalizedMessage id="field.color" />}
          errorText={errorText}
          value={value}
          adornments={{
            end: (
              <div role="button" tabIndex={0} onClick={handleClick}>
                <Avatar backgroundColor={value} size={20} variant="rounded">
                  <div />
                </Avatar>
              </div>
            ),
          }}
        />
      </div>
      <Popover
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        onClose={handleClose}
      >
        <SketchPicker
          disableAlpha
          presetColors={[]}
          color={value}
          onChange={(color) => onChange(color.hex)}
        />
      </Popover>
    </React.Fragment>
  );
};

ColorPicker.propTypes = {
  value: PropTypes.string.isRequired,
  errorText: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

ColorPicker.defaultProps = {
  errorText: null,
};

module.exports = ColorPicker;



// WEBPACK FOOTER //
// ./components/inputFields/ColorPicker.js